export default __webpack_public_path__ + "static/illustration-de275021041a362d0e65b7c77524d593.svg";